import React from 'react';
import { APP_STORE_URL } from '../utils/platformDetect';
import { trackEvent } from '../utils/promoTracking';
import { useLanguage } from '../contexts/LanguageContext';
import './EmptyStateAppPromo.css';

function EmptyStateAppPromo() {
  const { t } = useLanguage();

  const handleClick = () => {
    trackEvent('empty-state-promo-click');
    window.open(APP_STORE_URL, '_blank', 'noopener');
  };

  return (
    <div className="empty-state-promo" role="complementary">
      <img src="/logo192.png" alt="" width="32" height="32" className="empty-promo-icon" />
      <span className="empty-promo-text">{t('tryTheApp')}</span>
      <button className="empty-promo-cta" onClick={handleClick}>
        <img
          src="/app-store-badge.svg"
          alt={t('downloadApp')}
          className="empty-store-badge"
          onError={(e) => {
            e.target.style.display = 'none';
            e.target.nextSibling.style.display = 'inline';
          }}
        />
        <span style={{ display: 'none' }}>{t('downloadApp')}</span>
      </button>
    </div>
  );
}

export default EmptyStateAppPromo;
